import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SUBSCRIPTION } from '../constants/routes';

function TrialExpired() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full bg-gradient-to-b from-[#E8EBF3] via-[#F0F3FA] to-[#F8FAFC] flex flex-col items-center justify-center px-4 py-8">
      <div className="bg-white rounded-2xl shadow-xl p-10 max-w-md w-full text-center">
        {/* Warning Icon */}
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        <h1 className="text-2xl font-bold text-slate-900 mb-2">Trial Period Over</h1>
        <p className="text-slate-600 mb-8">
          Your trial has ended. Please upgrade to continue accessing all features.
        </p>

        <button
          onClick={() => navigate(SUBSCRIPTION)}
          className="w-full py-3 bg-gradient-to-r from-red-500 to-red-600 text-white font-semibold rounded-lg shadow-md hover:shadow-lg transition-all mb-3"
        >
          Upgrade Now
        </button>

        <button
          onClick={() => navigate('/login')}
          className="w-full py-3 bg-slate-200 text-slate-700 font-semibold rounded-lg hover:bg-slate-300 transition-all"
        >
          Log Out
        </button>
      </div>
    </div>
  );
}

export default TrialExpired;
